import React, { PureComponent, Fragment } from 'react';

import { ISession } from 'types';
import { getMapsImagePolyline } from 'components/map/utils';
// Data
import storeConnect from 'data/store-connect';
import boardStore from 'data/board';
import sessionStore, { updateSession } from 'data/session';

// Components
import Card from 'ui/card';
import Button from 'ui/button';
import { Loader } from 'ui/loader';
import { SessionBoard, SessionConditions } from 'components/session';
import styles from './overview.scss';
import { ICON_CHART } from 'icons';

interface OverviewProps {
  session: ISession;
}

const storeMap = {
  session: () => sessionStore.get(),
  boards: () => boardStore.list
};

@storeConnect(storeMap, [sessionStore, boardStore])
class SessionOverview extends PureComponent<OverviewProps> {
  handleBoardSelect = board => {
    updateSession(this.props.session.key, { board });
  };

  handleConditions = conditions => {
    updateSession(this.props.session.key, { conditions });
  };

  render() {
    const { session, boards } = this.props;
    if (!session) return <Loader />;
    const gps = session.gps;
    let coverStyle;
    if (gps) coverStyle = { backgroundImage: `url(${getMapsImagePolyline(gps.short, 640, 300)})` };

    return (
      <Fragment>
        <div className={styles.coverHolder}>
          <div className={`${styles.cover} flex row v-center h-center`} style={coverStyle}>
            {!gps && <Loader />}
          </div>
          <div className={styles.overlay}>
            <div className="center-content row padding v-end h-start" style={{ height: '100%' }}>
              <h1 className="flex tiny-margin">Session overview</h1>
              <Button
                raised="Show graphs"
                icon={ICON_CHART}
                big
                link={`/session/${session.key}/data`}
              />
            </div>
          </div>
        </div>
        <div className="center-content">
          <Card className="margin padding">
            <h2 className="tiny-margin">Rider</h2>
            <h3 className="text-fade">To be continued</h3>
            <h2 className="tiny-margin">Ride conditions</h2>
            <div className="row tiny-margin">
              <SessionConditions session={session} onChange={this.handleConditions} />
            </div>
            <h2 className="tiny-margin">Board</h2>
            <SessionBoard
              session={session}
              availableBoards={boards}
              onChange={this.handleBoardSelect}
            />
          </Card>
          <Card className="margin padding">
            <h2 className="tiny-margin">Comments</h2>
            <h3 className="text-fade">Comming soon</h3>
          </Card>
        </div>
      </Fragment>
    );
  }
}

export default SessionOverview;
